// import { SearchData, Item, Params, Input } from './useAttraqtIntegration.types';
// import { gtmPushEvent } from '~/helpers/gtm';

import { useLocalization } from '~/composables/_next/useLocalization';

const ATTRAQT_KEYS = {
  product: {
    fr: process.env.ATTRAQT_KEY_FR_PRODUCT_PAGE,
    it: process.env.ATTRAQT_KEY_IT_PRODUCT_PAGE,
    de: process.env.ATTRAQT_KEY_DE_PRODUCT_PAGE,
    en: process.env.ATTRAQT_KEY_EN_PRODUCT_PAGE,
    es: process.env.ATTRAQT_KEY_ES_PRODUCT_PAGE,
  },
  upsell: {
    fr: process.env.UP_SELL_FR,
    it: process.env.UP_SELL_IT,
    en: process.env.UP_SELL_EN,
    de: process.env.UP_SELL_DE,
    es: process.env.UP_SELL_ES,
  },
};

export function useAttraqt() {
  async function fetchUpsellProducts(basketItemsSkus: string[] = []) {
    const { locale } = useLocalization();
    const widgetId = ATTRAQT_KEYS.product[locale] ?? ATTRAQT_KEYS.upsell[locale];

    let apiUrl = `https://api.early-birds.io/widget/${widgetId}/recommendations`;

    const sessionId = localStorage.getItem('attraqtsessionid');

    if (sessionId) {
      apiUrl = `${apiUrl}/sessionId/${sessionId}`;
    }

    if (basketItemsSkus.length > 1) {
      const variableQuery = `variables={"$basketId": ["${basketItemsSkus.join('","')}"]}`;
      apiUrl = `${apiUrl}?${variableQuery}`;
    } else {
      const variableQuery = `variables={"$productid": "${basketItemsSkus[0]}"}`;
      apiUrl = `${apiUrl}?${variableQuery}`;
    }

    const result = await $fetch<Record<string, any>>(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // This code allows you to use the attraqt extension on chrome,
    // to get live details of the widjet used for the recommendation.
    // !!do not delete the next two lines!!

    window.ebRecoIds = window.ebRecoIds ?? [];
    window.ebRecoIds.push(result.id);

    return { widgetId, ...result };
  }

  return {
    fetchUpsellProducts,
  };
}
